import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppLottieModule } from './lottie.module';
import { LucideModule } from './lucide.module';
import { PrimeNGModule } from './primeng.module';
@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		PrimeNGModule,
		CdkCopyToClipboard,
		LucideModule,
		PortalModule,
		OverlayModule,
		AppLottieModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		PrimeNGModule,
		CdkCopyToClipboard,
		LucideModule,
		PortalModule,
		OverlayModule,
		AppLottieModule,
	],
})
export class SharedModule {}
